import gql from 'graphql-tag';

// History rows of any project on given paths, to tell whether a former URL of
// a project was used by another one as well.
export default gql`
  query getUrlHistoryClashes($where: project_url_history_bool_exp!) {
    project_url_history(where: $where) {
      project_id
      group_id
      slug_path
      first_seen
      last_seen
    }
  }
`;
